<template>
  <svg
    width="258"
    height="192"
    viewBox="0 0 258 192"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clip-path="url(#clip0_2787_13489)">
      <path
        d="M118.366 176.995C126.982 172.887 134.827 167.308 141.547 160.501L145.859 156.132L129.952 146.34L123.466 148.298C117.274 150.17 111.568 153.399 106.771 157.751L118.366 176.986V176.995Z"
        fill="#FFB339"
      />
      <path
        d="M104.883 162.477C104.571 167.769 108.156 174.001 112.893 176.386C117.63 178.771 121.717 176.412 122.029 171.12C122.341 165.828 118.756 159.596 114.019 157.212C109.282 154.827 105.195 157.185 104.883 162.477Z"
        fill="#2C89FF"
      />
      <path
        d="M106.562 163.859C106.562 167.68 109.247 172.337 112.555 174.252C115.863 176.167 118.539 174.626 118.539 170.805C118.539 166.984 115.854 162.328 112.555 160.413C109.247 158.498 106.562 160.038 106.562 163.859Z"
        fill="#399EFF"
      />
      <path
        d="M112.52 160.431C115.828 162.346 118.503 167.003 118.503 170.824C118.503 171.86 118.296 172.721 117.949 173.4C117.17 173.374 116.304 173.122 115.386 172.582C112.078 170.667 109.402 166.011 109.402 162.19C109.402 161.154 109.61 160.292 109.957 159.613C110.736 159.639 111.602 159.892 112.52 160.431Z"
        fill="#4A2730"
      />
      <path
        d="M155.724 180.519C161.63 177.699 167.007 173.878 171.614 169.213L174.575 166.219L163.673 159.508L159.222 160.848C154.979 162.128 151.065 164.347 147.774 167.333L155.724 180.519Z"
        fill="#FFB339"
      />
      <path
        d="M146.484 170.571C146.267 174.2 148.727 178.474 151.974 180.11C155.221 181.747 158.027 180.128 158.235 176.498C158.443 172.869 155.992 168.595 152.745 166.959C149.497 165.322 146.692 166.941 146.484 170.571Z"
        fill="#2C89FF"
      />
      <path
        d="M147.636 171.51C147.636 174.13 149.472 177.316 151.74 178.639C154.009 179.953 155.845 178.9 155.845 176.28C155.845 173.66 154.009 170.475 151.74 169.152C149.472 167.837 147.636 168.891 147.636 171.51Z"
        fill="#399EFF"
      />
      <path
        d="M151.723 169.161C153.992 170.475 155.827 173.669 155.827 176.289C155.827 177.003 155.689 177.595 155.446 178.056C154.91 178.039 154.321 177.864 153.689 177.499C151.42 176.185 149.584 172.99 149.584 170.37C149.584 169.657 149.723 169.065 149.965 168.604C150.502 168.621 151.091 168.795 151.723 169.161Z"
        fill="#4A2730"
      />
      <path
        d="M43.7306 110.966C49.6364 108.146 55.0139 104.325 59.6207 99.66L62.5823 96.6658L51.68 89.9551L47.2291 91.2955C42.9859 92.575 39.0718 94.7945 35.7812 97.7799L43.7306 110.966Z"
        fill="#FFB339"
      />
      <path
        d="M34.4908 101.018C34.2743 104.647 36.7336 108.921 39.9809 110.557C43.2282 112.194 46.0339 110.575 46.2417 106.945C46.4495 103.316 43.9989 99.0422 40.7516 97.4058C37.5043 95.7695 34.6986 97.3884 34.4908 101.018Z"
        fill="#2C89FF"
      />
      <path
        d="M35.6338 101.967C35.6338 104.587 37.4696 107.773 39.7384 109.096C42.0072 110.419 43.843 109.357 43.843 106.737C43.843 104.117 42.0072 100.932 39.7384 99.6086C37.4696 98.2856 35.6338 99.3474 35.6338 101.967Z"
        fill="#399EFF"
      />
      <path
        d="M39.7209 99.6176C41.9897 100.932 43.8255 104.126 43.8255 106.746C43.8255 107.46 43.6869 108.052 43.4445 108.513C42.9076 108.496 42.3188 108.322 41.6866 107.956C39.4178 106.642 37.582 103.447 37.582 100.827C37.582 100.114 37.7206 99.5219 37.963 99.0605C38.4999 99.078 39.0888 99.252 39.7209 99.6176Z"
        fill="#4A2730"
      />
      <path
        d="M55.1087 140.394C63.7249 136.285 71.5703 130.706 78.2901 123.9L82.6025 119.53L66.695 109.738L60.2091 111.697C54.0176 113.568 48.311 116.797 43.5137 121.149L55.1087 140.385V140.394Z"
        fill="#FFB339"
      />
      <path
        d="M41.6263 125.884C41.3146 131.176 44.8996 137.408 49.6363 139.793C54.373 142.177 58.4603 139.819 58.772 134.527C59.0838 129.235 55.4988 123.003 50.762 120.618C46.0253 118.233 41.938 120.592 41.6263 125.884Z"
        fill="#2C89FF"
      />
      <path
        d="M43.3066 127.258C43.3066 131.079 45.9911 135.735 49.2903 137.65C52.5982 139.565 55.2827 138.025 55.2827 134.204C55.2827 130.383 52.5982 125.726 49.2903 123.811C45.9824 121.896 43.3066 123.437 43.3066 127.258Z"
        fill="#399EFF"
      />
      <path
        d="M49.264 123.838C52.5719 125.753 55.2564 130.409 55.2564 134.23C55.2564 135.266 55.0485 136.128 54.7022 136.807C53.9228 136.78 53.0569 136.528 52.139 135.988C48.831 134.074 46.1553 129.417 46.1553 125.596C46.1553 124.56 46.3631 123.698 46.7095 123.02C47.4888 123.046 48.3548 123.298 49.2727 123.838H49.264Z"
        fill="#4A2730"
      />
      <path
        d="M179.649 32.1092L207.368 54.3477L188.577 68.8659L172.124 39.7512C171.648 39.0201 171.44 38.1932 171.474 37.3837C171.526 36.0172 171.474 35.3209 171.474 35.3209L177.12 31.9177C177.926 31.4564 178.93 31.5347 179.658 32.1179L179.649 32.1092Z"
        fill="#2C89FF"
      />
      <path
        d="M179.649 29.9236L207.368 52.1622L188.577 63.1204L172.124 37.5657C170.851 35.5899 171.492 32.9526 173.527 31.7863L177.112 29.7321C177.917 29.2708 178.922 29.3492 179.649 29.9323V29.9236Z"
        fill="#399EFF"
      />
      <path
        d="M122.496 108.86L80.6278 135.747L2.95241 52.3979C0.761571 50.0217 -0.34684 44.0073 0.0947921 41.3265L0.311279 40.0035C0.441171 39.2201 2.12977 38.9068 3.02169 39.5074L66.712 82.3916L122.488 108.869L122.496 108.86Z"
        fill="#2C89FF"
      />
      <path
        d="M122.497 105.491L80.6288 129.793L2.95339 49.0287C0.762547 46.6526 -0.345864 40.6381 0.0957686 37.9573L0.312255 36.6343C0.442147 35.851 2.13074 35.5376 3.02267 36.1382L66.713 79.0225L122.489 105.5L122.497 105.491Z"
        fill="#399EFF"
      />
      <path
        d="M30.819 161.171C25.5974 170.78 34.5772 181.921 45.0119 178.779C75.4932 169.588 104.277 155.435 130.221 136.896L222.687 68.8659C230.065 63.5913 248.249 40.0037 242.552 36.7571C238.889 34.6682 215.551 46.549 211.984 48.4465L66.8684 125.459C51.6277 133.545 39.0975 145.965 30.8364 161.162L30.819 161.171Z"
        fill="#BDE6FF"
      />
      <path
        d="M222.999 47.8355V1.59149C222.999 0.808134 222.159 0.320714 221.484 0.712391L219.423 1.90483C217.699 2.90578 216.392 4.4899 215.725 6.37865L203.775 40.5242C201.939 45.7726 199.54 50.8035 196.622 55.521L184.689 70.2481C184.689 70.2481 186.326 70.1436 188.283 69.3168C190.552 68.3506 206.104 60.6999 213.742 55.9475C218.288 53.1188 223.008 47.8442 223.008 47.8442L222.999 47.8355Z"
        fill="#399EFF"
      />
      <path
        d="M220.202 0.184227L218.349 1.28963C216.729 2.29058 215.431 3.84858 214.764 5.70252L205.013 32.7717C201.454 42.6507 196.527 51.9813 190.387 60.4938C190.387 60.4938 184.689 68.9801 184.689 70.0855V70.2422C186.456 70.2422 190.786 65.542 194.016 60.6852C197.237 55.8285 202.874 44.3044 205.819 35.6353L215.768 6.37272C216.409 4.47526 217.717 2.88245 219.44 1.8902L221.38 0.758686C221.787 0.462753 222.263 0.593312 222.263 0.593312L221.345 0.114595C220.921 -0.120411 220.488 0.00144437 220.211 0.175523L220.202 0.184227Z"
        fill="#E3F3FF"
      />
      <path
        d="M99.0039 143.502L137.937 120.906L183.564 153.276L247.566 185.289L257.957 188.214L257.992 191.269C257.654 191.539 257.23 191.774 256.597 191.808L254.311 191.939C249.687 192.2 239.322 191.556 235.235 190.277L96.0684 147.793V142.675L99.0039 143.502Z"
        fill="#2C89FF"
      />
      <path
        d="M137.937 118.383L96.0684 142.684L235.235 187.762C239.322 189.041 249.687 189.677 254.311 189.424L256.597 189.294C257.948 189.215 258.485 188.241 257.455 187.718L183.555 150.753L137.928 118.383H137.937Z"
        fill="#399EFF"
      />
      <path
        d="M256.268 77.4044C256.744 77.1259 257.03 76.6211 257.03 76.0727V74.7323L256.147 75.6288L252.83 77.5611C251.098 78.5707 249.072 78.945 247.089 78.6317L203.177 71.625V75.2023C203.177 75.2023 245.461 80.5117 247.219 80.6597C249.037 80.8076 251.055 80.4334 252.718 79.4759L256.268 77.4131V77.4044Z"
        fill="#2C89FF"
      />
      <path
        d="M256.571 74.0006L222.02 60.6836L203.186 71.6157L247.228 78.6398C249.124 78.9444 251.064 78.5789 252.726 77.6127L256.675 75.3236C257.212 75.0103 257.143 74.2182 256.571 74.0006Z"
        fill="#399EFF"
      />
      <path
        d="M84.5679 139.304C85.9101 138.591 86.4297 136.919 85.7196 135.562L85.1481 134.456C84.438 133.09 82.7581 132.567 81.3985 133.29C80.0563 134.004 79.5367 135.675 80.2468 137.033L80.8183 138.138C81.5284 139.504 83.2084 140.027 84.5679 139.304Z"
        fill="#4A2730"
      />
      <path
        d="M99.0034 130.906C100.346 130.192 100.865 128.521 100.155 127.163L99.5836 126.058C98.8735 124.691 97.1936 124.169 95.8341 124.891C94.4919 125.605 93.9723 127.276 94.6824 128.634L95.2539 129.74C95.964 131.106 97.6439 131.628 99.0034 130.906Z"
        fill="#4A2730"
      />
      <path
        d="M113.456 122.603C114.798 121.889 115.317 120.218 114.607 118.86L114.036 117.755C113.326 116.389 111.646 115.866 110.286 116.589C108.944 117.302 108.424 118.974 109.135 120.331L109.706 121.437C110.416 122.803 112.096 123.326 113.456 122.603Z"
        fill="#4A2730"
      />
      <path
        d="M127.882 114.203C129.225 113.489 129.744 111.818 129.034 110.46L128.463 109.355C127.752 107.988 126.073 107.466 124.713 108.188C123.371 108.902 122.851 110.573 123.561 111.931L124.133 113.036C124.843 114.403 126.523 114.925 127.882 114.203Z"
        fill="#4A2730"
      />
      <path
        d="M142.274 105.777C143.616 105.063 144.136 103.392 143.426 102.034L142.854 100.929C142.144 99.5623 140.464 99.0401 139.105 99.7625C137.762 100.476 137.243 102.147 137.953 103.505L138.524 104.611C139.234 105.977 140.914 106.499 142.274 105.777Z"
        fill="#4A2730"
      />
      <path
        d="M156.709 97.3785C158.052 96.6648 158.571 94.9936 157.861 93.6358L157.29 92.5304C156.58 91.1639 154.9 90.6417 153.54 91.3641C152.198 92.0778 151.678 93.749 152.388 95.1068L152.96 96.2122C153.67 97.5787 155.35 98.1009 156.709 97.3785Z"
        fill="#4A2730"
      />
      <path
        d="M171.154 89.066C172.496 88.3523 173.016 86.6811 172.306 85.3233L171.734 84.2179C171.024 82.8514 169.344 82.3292 167.984 83.0516C166.642 83.7653 166.123 85.4365 166.833 86.7943L167.404 87.8997C168.114 89.2662 169.794 89.7884 171.154 89.066Z"
        fill="#4A2730"
      />
      <path
        d="M54.0175 148.305C54.0175 148.305 56.8837 147.113 57.0483 147.008L62.4777 143.814C63.3524 143.301 64.4521 143.405 65.2141 144.075L67.8206 146.382C69.0243 147.444 68.8338 149.376 67.4569 150.185L61.1961 153.867C60.1743 154.511 55.4289 156.191 55.4289 156.191L54.0088 148.297L54.0175 148.305Z"
        fill="#4A2730"
      />
      <path
        d="M42.821 144.215L45.4448 146.469C47.8868 148.41 51.0475 149.046 54.0177 148.306L55.4378 156.2C54.1822 156.479 52.9006 156.653 51.6277 156.653C47.6703 156.653 43.7302 155.347 40.4916 152.762L37.7119 150.429C39.3745 148.332 40.9765 146.147 42.8297 144.215H42.821Z"
        fill="#4A2730"
      />
      <path
        d="M39.9636 147.549C39.2362 148.471 38.5174 149.403 37.79 150.317C38.4915 149.377 39.2189 148.454 39.9636 147.549Z"
        fill="url(#paint0_linear_2787_13489)"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_2787_13489"
        x1="38.8811"
        y1="148.933"
        x2="39.4917"
        y2="149.887"
        gradientUnits="userSpaceOnUse"
      >
        <stop stop-color="#E4DEFA" />
        <stop offset="1" stop-color="#1736D2" />
      </linearGradient>
      <clipPath id="clip0_2787_13489">
        <rect width="258" height="192" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
